import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthInterceptor } from './data/http/auth-interceptor';
import { LanguageService } from './translation/language.service';
import { ToastComponentModule } from '@components/toast/toast.module';
import { ToastService } from './state/toast/toast.service';
import { LocationService } from './services/location.service';
import { GlobalsDataService } from './data/api/global/global-data.service';
import { IndustriesDataService } from './data/api/industry/industries-data.service';
import { AutocompleteService } from '@vendor/google/autocomplete.service';
import { MapsLoaderService } from '@vendor/google/maps-loader.service';
import { PlacesService } from '@vendor/google/places.service';
import { GlobalService } from './services/global.service';
import { SearchService } from './services/search.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ToastComponentModule
    ],
    providers: [
        LanguageService,
        LocationService,
        GlobalsDataService,
        IndustriesDataService,
        AutocompleteService,
        MapsLoaderService,
        PlacesService,
        GlobalService,
        SearchService
    ]
})
export class CoreModule {

    /**
     * Use this method in your root module to provide the services
     * @returns {ModuleWithProviders}
     */
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [
                AuthInterceptor
            ]
        };
    }

    /**
     * Use this method in your other (non root) modules to import the directive/pipe
     * @returns {ModuleWithProviders}
     */
    static forChild(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule
        }
    }
}
